// Utilities
import debounce from '../../js/modules/debounce'

export default function () {
  var isshrunk = false,
    vtopposition

  // JS to detect when we're scrolled down the page and can 'squish' or 'shrink' the navbar
  // The styles for this change only work if flexbox is present. Since the flexbox we're using here is protected behind CSS @supports directives we'll feature detect @supports rather that the buggy flexbox supports. Some browsers proclaim they can do flexbox when their implementations are buggy enough to be unusable.
  if (Modernizr.supports) {
    var siteheaderresize = debounce(function () {
      requestAnimationFrame(function () {
    // All the taxing stuff you do
        vtopposition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (vtopposition > 70 && !isshrunk) {
          isshrunk = true
          $('.siteheader').first().addClass('js-shrink')
        } else if (vtopposition < 40 && isshrunk) {
          isshrunk = false
          $('.siteheader').first().removeClass('js-shrink')
        }
      }, 200, true)
    })
  }

  // JS to detect if the browser supports position:sticky using Modernizr and IF it doesn't to add a CSS fallback.

  if (Modernizr.csspositionsticky) {
  // supported
  } else {
    // not-supported
    // position the element with fixed
    $('.siteheader').css({
      'position': 'fixed',
      'top': '0',
      'left': '0',
      'right': '0'
    })

    $('body').prepend('<div class="ghost-siteheader">')
  }

  window.addEventListener('scroll', siteheaderresize)
}
